// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"fc08fc35","703":"aa78e195","787":"2eb4e976"}[chunkId] + ".chunk.js";
};